export default {
  name: 'BarCode',
  displayName: { ja: 'バーコード生成', en: 'Barcode' },
  resizeX: true,
  props: [
    {
      name: 'value',
      displayName: {
        ja: 'バーコードの値',
        en: 'Barcode value',
      },
      type: 'number',
      disableDynamicValues: false,
      helpText: 'Barcode value...',
      canvas: {
        onlyNumber: true,
        // default: '123456789',
      },
      enabled: {
        format: ['CODE128', 'CODE39', 'EAN13', 'UPC', 'ITF', ''],
      },
      // hideCollection: true,
      // hideFormInputs: true,
      // isOnlyNumberField: true,
      // regexReplace: /[^A-Z0-9\s\-\.\$\/\+\%]+/g,
      // isUpperCase: true,
    },
    {
      name: 'codabarValue',
      displayName: {
        ja: 'バーコードの値 (NW-7)',
        en: 'Barcode value (NW-7)',
      },
      type: 'text',
      disableDynamicValues: false,
      helpText: 'NW-7 (Codabar) value. Allows digits 0-9 and - $ : / . +',
      enabled: {
        format: 'Codabar',
      },
    },
    // only open this option for Platio env
    // {
    //   name: 'format',
    //   displayName: {
    //     en: 'Format',
    //     ja: 'フォーマット',
    //   },
    //   type: 'text',
    //   default: 'CODE128',
    //   control: {
    //     type: 'menu',
    //     options: [
    //       { label: 'CODE128 (default)', value: 'CODE128' },
    //       { label: 'Codabar (NW-7)', value: 'Codabar' },
    //       { label: 'CODE39', value: 'CODE39' },
    //       { label: 'EAN-13', value: 'EAN13' },
    //       { label: 'UPC', value: 'UPC' },
    //       { label: 'ITF', value: 'ITF' },
    //     ],
    //   },
    // },
    {
      name: 'autoWrap',
      displayName: {
        en: 'Auto-wrap Codabar start/stop (A...A)',
        ja: 'Codabarの開始/終了文字を自動付与 (A...A)',
      },
      type: 'boolean',
      default: true,
      enabled: {
        format: 'Codabar',
      },
    },
    {
      name: 'onPress',
      type: 'action',
      displayName: {
        en: 'Click Actions',
        ja: 'Click Actions',
      },
    },
  ],
  resizeY: true,
};
